var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1412_885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7361 0.277751C20.3194 -0.0903049 19.6875 -0.0903049 19.2639 0.277751L0.37496 16.9444C-0.083373 17.3472 -0.131984 18.0555 0.277738 18.5139C0.68746 18.9722 1.38885 19.0208 1.84718 18.6111L4.44441 16.3194V30C4.44441 33.0694 6.93052 35.5555 9.99996 35.5555H30C33.0694 35.5555 35.5555 33.0694 35.5555 30V16.3194L38.1527 18.6111C38.6111 19.0139 39.3125 18.9722 39.7222 18.5139C40.1319 18.0555 40.0833 17.3541 39.625 16.9444L20.7361 0.277751ZM6.66663 30V14.3541L20 2.59025L33.3333 14.3541V30C33.3333 31.8403 31.8402 33.3333 30 33.3333H25.5555V22.2222C25.5555 20.993 24.5625 20 23.3333 20H16.6666C15.4375 20 14.4444 20.993 14.4444 22.2222V33.3333H9.99996C8.15968 33.3333 6.66663 31.8403 6.66663 30ZM16.6666 33.3333V22.2222H23.3333V33.3333H16.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1412_885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35.5556,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.4f81eee6858da6fa1432637bef386775.svg";
export { ForwardRef as ReactComponent };